// Hàm lấy đuôi file từ tên file
export const getFileExtension = (fileName: string): string => {
  const extension = (fileName ?? "").split(".").pop();
  return extension ? extension.toLowerCase() : "";
};

export enum IMAGE_EXTENSION {
  JPG = "jpg",
  JPEG = "jpeg",
  PNG = "png",
  GIF = "gif",
  BMP = "bmp",
  WEBP = "webp",
  SVG = "svg",
  TIFF = "tiff",
  ICO = "ico",
}

export enum DOC_EXTENSION {
  DOC = "doc",
  DOCX = "docx",
}

export enum EXCEL_EXTENSION {
  XLS = "xls",
  XLSX = "xlsx",
}

export enum ZIP_EXTENSION {
  ZIP = "zip",
  RAR = "rar",
  TAR = "tar",
  GZ = "gz",
}

export enum PDF_EXTENSION {
  PDF = "pdf",
}

export const isImage = (fileName: string): boolean => {
  const extension = getFileExtension(fileName);
  return Object.values(IMAGE_EXTENSION).includes(extension as IMAGE_EXTENSION);
};

export const isDoc = (fileName: string): boolean => {
  const extension = getFileExtension(fileName);
  return Object.values(DOC_EXTENSION).includes(extension as DOC_EXTENSION);
};

export const isExcel = (fileName: string): boolean => {
  const extension = getFileExtension(fileName);
  return Object.values(EXCEL_EXTENSION).includes(extension as EXCEL_EXTENSION);
};

export const isZip = (fileName: string): boolean => {
  const extension = getFileExtension(fileName);
  return Object.values(ZIP_EXTENSION).includes(extension as ZIP_EXTENSION);
};

export const isPdf = (fileName: string): boolean => {
  const extension = getFileExtension(fileName);
  return Object.values(PDF_EXTENSION).includes(extension as PDF_EXTENSION);
};
